import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { useScheduleState } from 'domains/direct-schedule/useScheduleProvider';
import ScheduleUI from './ui';

export const Schedule = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { clientId, scheduleId } = useParams<{ clientId: string; scheduleId: string }>();
  const { scheduleQuery } = useScheduleState();

  if (!clientId || !scheduleId) {
    throw new Error(t('errors.invalidClientState'));
  }

  if (scheduleQuery.isLoading) {
    return <ScheduleUI loading />;
  }

  if (scheduleQuery.isError) {
    return <ScheduleUI isError />;
  }

  if (scheduleQuery.isSuccess && scheduleQuery.data.status === 'active') {
    return <ScheduleUI />;
  }

  if (scheduleQuery.data?.status !== 'active') {
    // TODO: Update this to redirect to the correct page
    return <Navigate to="/reschedule/expired" />;
  }

  return null;
};

export default Schedule;
